import {
    Flex, Heading,
    Table, Thead, Tbody, Tr, Th, Td,
    Alert, AlertIcon, AlertTitle, AlertDescription,
    IconButton, Icon, Link, Button, FormControl,
    useToast,
    VStack,
    FormErrorMessage,
    Stack,
    HStack,
    TableContainer
} from '@chakra-ui/react'
import React from 'react'
import { useForm } from 'react-hook-form'
import InputUploadFile from '../shared/InputUploadFile'
import { BsEye, BsExclamationTriangle, BsCheckBox, BsBoxArrowInDown } from "react-icons/bs"
import { uploadFile } from '../../classes/FormRequest'
import { useUserContext } from '../../context/userContext'
import { toastErrDesc, toastVal } from '../../utils/toastUtils';
import { useFormRquestContext } from '../../context/formRequestContext'
import { useHistory, Link as ReactLink } from 'react-router-dom'


const FileViewButton = ({ path }) => {
    if (path) {
        return (
            <Link href={path} isExternal textDecor="none">
                <IconButton icon={<BsEye />} colorScheme="green" size="sm" />
            </Link>
        )
    } else {
        return (<>-</>)
    }
}

const FileStatusLabel = ({ path }) => {
    if (path) {
        return (<Icon as={BsCheckBox} color="green" />)
    } else {
        return (<Icon as={BsExclamationTriangle} color="red" />)
    }
}


const TrAttatchments = ({ doc, otherdoc, index, register, errors }) => {
    const { name, id } = doc.scan_document
    const indexName = `file_${id}`
    const nameText = id === 6 ? `${name} - ${otherdoc}` : name

    return (
        <Tr>
            <Td>{`${index + 1}.`}</Td>
            <Td>{nameText}</Td>
            <Td>
                <VStack w="full">
                    <FormControl isInvalid={errors[indexName]}>
                        <InputUploadFile name={indexName} register={register} />
                        {errors[indexName] && <FormErrorMessage>กรุณาเลือกไฟล์</FormErrorMessage>}
                    </FormControl>
                </VStack>
            </Td>
            <Td><FileStatusLabel path={doc.file_path_url} /></Td>
            <Td><FileViewButton path={doc.file_path_url} /></Td>
        </Tr>
    )
}


const AttatchmentsTableBody = () => {
    const { handleSubmit, register, reset, formState: { errors } } = useForm()
    const { userData } = useUserContext()
    const toast = useToast()
    const { formReqData, setFormReqData } = useFormRquestContext()
    const history = useHistory()

    const onSubmit = async (fData) => {
        // console.log(fData)
        const fmData = new FormData()
        for (const key in fData) {
            fmData.append(key, fData[key][0])
        }

        await uploadFile(formReqData.id, fmData, userData.token)
            .then(res => {
                // console.log(res)
                toast(toastVal({
                    title: "การบันทึกข้อมูลสำเร็จ",
                    description: `บันทึกข้อมูล เรียบร้อยแล้ว`,
                }))
                reset()
                setFormReqData(res)

                if (res.id) {
                    //redirect to home
                    history.push(`/form/${res.id}/step3`)
                }
            })
            .catch(error => {
                // console.log(error)

                toast(toastVal({
                    title: "การบันทึกข้อมูล ไม่สำเร็จ",
                    description: toastErrDesc(error),
                    status: "error",
                }))
            })


    }

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <TableContainer>
                <Table variant="simple" size="sm" mt={10}>
                    <Thead>
                        <Tr>
                            <Th w="20px">ลำดับ</Th>
                            <Th>ชื่อเอกสาร</Th>
                            <Th>อัพโหลด</Th>
                            <Th w="100px">สถานะ</Th>
                            <Th w="100px">ดูไฟล์</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {/* <Tr>
                        <Td>1.</Td>
                        <Td>แบบฟอร์มคำร้องขอเข้าพัก</Td>
                        <Td>
                            <VStack w="full">
                                <FormControl isInvalid={errors.file}>
                                    <InputUploadFile name="file" register={register} />
                                    {errors.file && <FormErrorMessage>กรุณาเลือกไฟล์</FormErrorMessage>}
                                </FormControl>
                            </VStack>
                        </Td>
                        <Td><FileStatusLabel path={formReqData.file_path_url} /></Td>
                        <Td><FileViewButton path={formReqData.file_path_url} /></Td>
                    </Tr> */}
                        <Tr>
                            <Td colSpan={5} bgColor="blue.100">เอกสารประกอบ</Td>
                        </Tr>
                        {
                            formReqData.form_request_scan_document && formReqData.form_request_scan_document?.map((doc, index) =>
                                <TrAttatchments doc={doc} otherdoc={formReqData.other_document_name} index={index} register={register} errors={errors} key={`tr_doc_${index}`} />)
                        }
                    </Tbody>
                </Table>
            </TableContainer>
            <Flex w="full" mt={6} align="center" direction="column">
                <Button leftIcon={<BsBoxArrowInDown />} type="submit" colorScheme="blue">บันทึกข้อมูล</Button>
                <Link to="/" as={ReactLink}>
                    <Button fontSize="md" variant="link" mt={4}>
                        กลับหน้าหลัก
                    </Button>
                </Link>
            </Flex>
        </form>
    )
}

const AlertWarningNote = () => {
    return (
        <Alert status="warning" mt={6}>
            <Stack w="full" direction={{ base: "column", md: "row" }}>
                <HStack>
                    <AlertIcon />
                    <AlertTitle mr={2}>คำชี้แจง</AlertTitle>
                </HStack>
                <AlertDescription>ไฟล์ที่ใช้อัพโหลดต้องเป็นชนิด PDF และขนาดไม่เกิน 1 MB กรุณาตรวจสอบเอกสารก่อนทำการบันทึกข้อมูล</AlertDescription>
            </Stack>
        </Alert>
    )
}

const AttachmentsTable = () => {

    return (
        <Flex direction="column" w="full">
            <Heading as="h6" size="sm" mt={6}>รายการไฟล์แนบ</Heading>
            <AlertWarningNote />
            <AttatchmentsTableBody />
        </Flex>
    )
}

export default AttachmentsTable
